import { Box, Typography } from '@mui/material';
import CustomAlert from 'components/shared/CustomAlert/CustomAlert';
import { initialAlertState, useAlertStatus } from 'customHook/useAlertStatus';
import { DealsService } from 'service/deals.service';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setOwner, setStage } from 'store/slices/dealsSlice';
import zeplinColor from 'theme/Color';
import DealDropdown from '../../DealDropdown';

export type OptionType = { value: string; label: string };

const Section = ({ data, label }: { data: any; label: string }) => {
  const dispatch = useAppDispatch();
  const { owners, stages, stage, owner, formattedOwners } = useAppSelector((state) => state.deals);
  const { dealId } = useAppSelector((state) => state.deals.deal);

  const { startOperation, alertState, setAlertState, getAlertContent, completeOperation } =
    useAlertStatus();

  const handleFieldChange = async (fieldName: string, newValue: string) => {
    if (!dealId) return;

    try {
      startOperation('update', 'Updating deal...');
      if (fieldName === 'ownerName') {
        const owner = owners.find((item) => item.email === newValue);

        await DealsService.updateDeal(dealId, {
          [fieldName]: `${owner.firstName} ${owner.lastName}`,
          owner,
        });
      } else {
        console.log('hello');
        await DealsService.updateDeal(dealId, { [fieldName]: newValue });
      }

      completeOperation('update', 'Deal updated successfully.');
    } catch (error: any) {
      completeOperation('update', error?.response?.data?.message || 'Failed to update deal', true);
    }
  };

  const handleOwnerChange = (fieldName: string, value: string) => {
    dispatch(setOwner(value));
    handleFieldChange(fieldName, value);
  };
  const handleStageChange = (fieldName: string, value: string) => {
    dispatch(setStage(value));
    handleFieldChange(fieldName, value);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <Typography variant='responsiveHeading3' sx={{ color: zeplinColor.BasicBlack }}>
        {label}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          flexWrap: 'wrap',
          columnGap: '6%',
          rowGap: '32px',
        }}
      >
        {data.map((item: any) => {
          return (
            <Box
              key={item.label}
              sx={{ width: 'calc(46%)', display: 'flex', justifyContent: 'space-between' }}
            >
              <Box sx={{ width: 'calc(50%)', display: 'flex' }}>
                <Typography variant='responsiveBody2' sx={{ color: zeplinColor.Neutral8 }}>
                  {item.label}
                </Typography>
              </Box>
              <Box sx={{ width: 'calc(50%)', display: 'flex' }}>
                {item.fieldName === 'stageName' && (
                  <DealDropdown
                    options={stages}
                    value={stage}
                    setValue={handleStageChange}
                    fieldName='stageName'
                  />
                )}
                {item.fieldName === 'ownerName' && (
                  <DealDropdown
                    options={formattedOwners}
                    value={owner}
                    setValue={handleOwnerChange}
                    fieldName='ownerName'
                  />
                )}

                {!item.isSelect && (
                  <Typography variant='responsiveBody2' sx={{ color: zeplinColor.BasicBlack }}>
                    {item.format ? item.format(item.value) : item.value}
                  </Typography>
                )}
              </Box>
            </Box>
          );
        })}
      </Box>

      <CustomAlert
        open={alertState.status !== 'idle'}
        handleClose={() => setAlertState(initialAlertState)}
        message={getAlertContent(alertState)}
        error={alertState.status === 'error'}
      />
    </Box>
  );
};

export default Section;
